export default __webpack_public_path__ + "static/media/applyLeaveWhite.44631bea.svg";